// Unpublished Work © 2020-2026 Deere & Company.

import React from 'react';
import {createRoot} from 'react-dom/client';
import {RoutesProvider} from './routes-provider';
import './index.css';

const root = createRoot(globalThis.document.querySelector('#ui-core'));

root.render(
    <RoutesProvider/>
);
